import '@resources/sw/init'

import './bootstrap'

import store from './store'
import router from './router'

import VueGtag from "vue-gtag"

Vue.use(VueGtag, {
    config: {
        id: window.kmenv.gaid || '',
    },
}, router)

const app = new Vue({
    el: '#root',
    store,
    router
})
